
import {ref, defineComponent, watchEffect} from 'vue'
import store, {ActionTypes} from '../../store'
import {mapActions, mapState, mapGetters} from 'vuex'
import {Index, IndicesCategories, User} from '../../types'
import IndexList from '../../components/buildertools/IndexList.vue'
import UserIndexList from '../../components/buildertools/UserIndexList.vue'
import LegVolumesHistoryPanel from '../../components/panels/LegVolumesHistoryPanel.vue'
import {useRoute, useRouter} from 'vue-router';

export default defineComponent({
  name: 'Strategies',
  components: {
    IndexList,
    UserIndexList,
    LegVolumesHistoryPanel
  },
  emits: ['selectUser'],
  setup() {
    const router = useRouter()
    const route = useRoute()
    let isStratSelected = ref(false);
    watchEffect(() => {
      isStratSelected.value = Object.keys(route.params).length === 0 && !route.path.includes('/create/');
    });

    return {
      router,
      isStratSelected
    }
  },
  data() {
    return {
      IndicesCategories,
      tabvalue: IndicesCategories.ASSIGNED,
    }
  },

  computed: {
    ...mapState(['indices', 'users', 'user', 'is_staff']),
    ...mapGetters(['currentUser'])
  },
  async mounted() {
    await store.dispatch(ActionTypes.FETCH_PRODUCTS).then(async () => {
      await store.dispatch(ActionTypes.FETCH_INDICES, this.tabvalue)
    })
  },
  methods: {
    ...mapActions({
      fetchStrategies: ActionTypes.FETCH_INDICES,
      fetchUserStrategies: ActionTypes.FETCH_USER_INDICES
    }),
    setStratCategoryTab(event: Event) {
      const target = event.target as HTMLInputElement
      store.state.tabvalue = target.value
      let value
      switch (target.value) {
        case 'house':
          if (this.is_staff && !this.users) {
            store.dispatch(ActionTypes.FETCH_USERS)
          }
          this.tabvalue = IndicesCategories.HOUSE,
              this.router.push('/stratslist')
          break;
        case 'users':
          store.dispatch(ActionTypes.FETCH_USERS_WITH_STRATS)
          this.tabvalue = IndicesCategories.USERS
          break;
        default:
          if (this.is_staff && !this.users) {
            store.dispatch(ActionTypes.FETCH_USERS)
          }
          this.tabvalue = IndicesCategories.ASSIGNED
          this.router.push('/stratslist')
          break
      }
      if (value === this.tabvalue) return
      this.fetchStrategies(this.tabvalue)
    },
    setSelectedUser(user: User) {
      return this.fetchUserStrategies(user.id)
    }
  }
})
